import React from 'react';
import PropTypes from 'prop-types';
import {getClassList} from "../../Utility/siteConfig";
import NewItemPicture from "./NewItemPicture";
import NewItemDetails from "./NewItemDetails";

// 2023-11 added VehicleDisplay (from cart) - display a alert when vehicle missing
// 2023-04 modernized, camelized props
export default function NewItemDisplay({
  className,
  newItem, shoppingCart, handleClose, customerVehicle}) {

  if (!newItem)
    return null;

  // removed for carlyle<div className="shipping">Free shipping</div>
  className = getClassList({
    key: "DynamicCartPopup.NewItemDisplay",
    base: [className, ""],
    fallback: ['p-2 border-top border-gray-100 text-pencil bg-paper']
  });

  return (
    <div className={className}>
      <div className="lg:grid lg:grid-cols-3 lg:gap-4">
        <NewItemPicture item={newItem} />
        <div className="lg:col-span-2">
          <NewItemDetails
            item={newItem}
            handleClose={handleClose}
            customerVehicle={customerVehicle}
            shoppingCart={shoppingCart} />
        </div>
      </div>
    </div>
  );
}


NewItemDisplay.propTypes = {
  newItem: PropTypes.object.isRequired,
  handleClose: PropTypes.func.isRequired
};


